import axios from "axios";

export function setAuthorization(token) {
  if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export function deleteAuthorization(){
  delete axios.defaults.headers.common["Authorization"];
}

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    setAuthorization,
    deleteAuthorization
}


// WEBPACK FOOTER //
// ./src/services/httpService.js